<template>
  <v-app id="app">
    <router-view/>
  </v-app>
</template>

<style>

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  background-color: #222621;
}
.toolbar--material__left img {
  margin: 0px auto auto 15px;
}
.toolbar--material__center {
  text-align: center !important;
}
.toolbar--material__right {
  color: #fff !important;
  margin-right: 30px !important;
  width: 275px !important;
}
#menuPopover .popover--material {
  top: 50px !important;
  right: 30.8182px !important;
}
.dialogTrocaSenha h2 {
  color: #000;
  text-align: center;
}
.dialogTrocaSenha ons-input {
  background-color: #fff;
  width: 50%;
  border-radius: 5px;
  border-bottom: 1px solid #999999;
}
.dialogTrocaSenha v-ons-label {
  margin-left: 15px;
  min-width: 50px;
  display: inline-flex;
  justify-content: flex-end;
  text-align: right;
}


</style>

<script>
import { isNullOrUndefined } from "util";


export default {
  name: "QrServiceAdmin",
  data() {
    return {
      wsStatus: false,
      wsLastMassage: "",
      e: {},
      logado: false,
      showMenu: false,
      dialogTrocarSenha: false,
      trocaSenha: {},
      popoverVisible: false,
      popoverTarget: null,
      popoverDirection: "up",
      coverTarget: false,
      
    };
  },
  created() {
    var e = localStorage.getItem("e");
    if (!isNullOrUndefined(e)) {
      
      this.e = JSON.parse(e);
      this.logado = true;
      localStorage.setItem("makeLogin", false);
    }
  },
  methods: {
    erroCardapio() {
      window.console.log("chegou");
    },
    trocarSenha() {
      if (this.trocaSenha.novaSenha != this.trocaSenha.confirmaNovaSenha) {
        this.$ons.notification.toast(
          "A confirmação não coincide com a nova senha! ",
          { timeout: 1000, animation: "ascend" }
        );
        return;
      }
      this.trocaSenha.idEstabelecimento = this.e.idEstabelecimento;
      fetch(this.$menu_uri + "/trocar-senha", {
        method: "OPTIONS",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(this.trocaSenha),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data === 1) {
            this.trocaSenha = {
              sAtual: "",
              novaSenha: "",
              confirmaNovaSenha: "",
            };
            (this.dialogTrocarSenha = false),
              this.$ons.notification.toast("Senha alterada com sucesso! ", {
                timeout: 1000,
                animation: "ascend",
              });
          } else {
            this.$ons.notification.toast(
              "Ocorreu um erro, confira sua senha atual! ",
              { timeout: 1000, animation: "ascend" }
            );
          }
        })
        .then((error) => {
          if (error) {
            window.log(error);
            this.$ons.notification.toast("Erro de rede, tente novamente! ", {
              timeout: 1000,
              animation: "ascend",
            });
          }
        });
    },
    showPopover(event, direction, coverTarget = false) {
      this.popoverTarget = event;
      this.popoverDirection = direction;
      this.coverTarget = coverTarget;
      this.popoverVisible = true;
    },
    openTermosUso() {
      var w = window.open(this.$menu_base + "/termos-de-uso", "_blank");
      w.focus();
    },

    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
  },
};
</script>
